module.exports = __webpack_public_path__ + "829671f2f7d0930930f850bc7d20f052.png";